import React, { Component } from 'react';

import { toRoman } from 'roman-numerals';

import ModuleBlock from './components/ModuleBlock';

import './LearningRoadmap.scss';

class LearningRoadmap extends Component {
  render () {
    return (
      <div className='student-report-learning-roadmap'>
        <div className='container'>
          <div className='row justify-content-md-center mobile-sticky'>
            <div className='col-md-8'>
              <div className='student-report-learning-roadmap__header-title'>
                <h2>Your Learning Roadmap</h2>
              </div>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8'>
              <div className='student-report-learning-roadmap__header-paragraph'>
                <p>Based on your interests and skills, we recommend the following sample learning plan. We’ve identified suggested advisors and sessions for you, but you may also seek out analogous learning experiences on your own.</p>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              {this.props['student-report-data'].learning_plan.map((entry, index) => (
                <div className='student-report-learning-roadmap-entry' key={index}>
                  <h3>{toRoman(index + 1)}. {entry.advisor_goal}</h3>
                  <ModuleBlock module-block-data={entry} />
                </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LearningRoadmap;



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/LearningRoadmap/index.js